import { useFormContext } from 'react-hook-form';

import { systemProductCategorySlug } from '../../../../../constants/systemProductCategorySlug';
import GenericSwitchboardSettingsProductSelect from './GenericSwitchboardSettingsProductSelect';

export default function MeterBoxPlateSelect({
  isDisabled,
  isRequired = false
}) {
  const { watch } = useFormContext();

  const horizontalModules = watch('horizontalModulesPerRow');

  const params = {
    horizontalModules,
    categorySlug: systemProductCategorySlug.MeterBoxPlate
  };

  return (
    <GenericSwitchboardSettingsProductSelect
      isDisabled={isDisabled}
      isRequired={isRequired}
      displayName="Meter Box Plate"
      inputName="counterPlate"
      params={params}
    />
  );
}
